import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { Background, BannerContent, BannerImage, BannerSection } from './BannerStyles';
import { Arrow, Colors } from 'src/styles/DesignSystem';

import banner from 'src/assets/uploads/banner.png';
import TitleSection from 'src/components/TitleSection';
import Cta from 'src/components/Cta';

import bgImage from 'src/assets/bg-image.png';

const Banner = ({
    title, subtitle
}) => {

    const linkto = useNavigate();

    const toInstitucional = () =>{
        linkto('/institucional');
    }

    return (
        <BannerSection>
            <Background src={bgImage} alt="  " />
            <BannerContent>
                <TitleSection textColor={Colors.brown}>{title}</TitleSection>
                <p>{subtitle}</p>

                <footer>
                    <Cta onclick={toInstitucional}>
                        Saiba mais
                        <Arrow />
                    </Cta>
                    <Link to="/contato">Entrar em contato</Link>
                </footer>
            </BannerContent>

            <BannerImage>
                <img src={banner} alt={title} />
            </BannerImage>
        </BannerSection>
    )
}

export default Banner;